export const CLOSE_MODAL = 'CLOSE_MODAL';
export const OPEN_ORDER_MODAL = 'OPEN_ORDER_MODAL';
export const UPDATE_ORDER_MODAL: 'UPDATE_ORDER_MODAL' = 'UPDATE_ORDER_MODAL';
export const GET_ORDER_MODAL_REQUEST = 'GET_ORDER_MODAL_REQUEST';
export const GET_ORDER_MODAL_SUCCESS = 'GET_ORDER_MODAL_SUCCESS';
export const GET_ORDER_MODAL_FAILED = 'GET_ORDER_MODAL_FAILED';

export const OPEN_INGREDIENT_MODAL = 'OPEN_INGREDIENT_MODAL';
export const SELECT_INGREDIENT = 'SELECT_INGREDIENT';

export const OPEN_FEED_MODAL = 'OPEN_FEED_MODAL';
export const SELECT_FEED_INGREDIENT = 'SELECT_FEED_INGREDIENT';